import { useCallback, useState } from "react";
import { SearchBrandsInput } from "components/UI/molecules";
import { HomeContainer } from "components/UI/atoms";
import { DEFAULT_VALUE_CURRENT_SEARCH_BAR } from "constants/brands";
import { useSearchBarIsVisible } from "./utils/useSearchBarIsVisible";
import { SearchBrandsDropdown } from "../search-brands-dropdown";
import "./index.scss";

const MainSearch = () => {
  const [canShowDropdown, setCanShowDropdown] = useState(false);
  const [brands, setBrands] = useState([]);
  const { elementIsVisible, containerRef } = useSearchBarIsVisible();

  const handleBrandsChange = useCallback((brandsChanged) => {
    setBrands(brandsChanged);
  }, []);
  const { ctaCopy, title, subtitle, inputPlaceholder } =
    DEFAULT_VALUE_CURRENT_SEARCH_BAR;

  return (
    <HomeContainer>
      <section className="main-search" ref={containerRef}>
        <h2 className="search-title">{title}</h2>
        <h3 className="search-subtitle">{subtitle}</h3>
        <div
          className={`search-form-container ${
            !elementIsVisible ? "fixed-container" : ""
          }`}
        >
          <SearchBrandsInput
            placeholder={inputPlaceholder}
            searchButtonLabel={ctaCopy}
            onBrandsChange={handleBrandsChange}
            shouldShowDropdown={(value) => setCanShowDropdown(value)}
            variant="desktop"
          />
          <div className="dropdown-container">
            <SearchBrandsDropdown
              canShowDropdown={canShowDropdown}
              brands={brands}
            />
          </div>
        </div>
      </section>
    </HomeContainer>
  );
};

export default MainSearch;
